import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { _serverUrl2 } from "../../../config";
import { failed, success } from "../../../Utils/Alerts";
import { loadingSc, WarningAlert } from "../../Layout/AlertDiv";
import { addFeaturesTotempLayer, tempLayer, zoomToFeatureByXY } from "../../Map/Layers/TempLayer";
import { MyMap } from "../../Map/View/MyMap";
import DataSidebar from "./DataSidebar";

export default function DataHSign() {
  const getUserInfo = useSelector((state) => state.getUserInfo);

  // Adres
  const [ilce, setIlce] = useState([]);
  const [mahalle, setMahalle] = useState([]);
  const [csbm, setCsbm] = useState([]);
  const [kapi, setKapi] = useState([]);

  // Tablo Verileri
  const [selectedSourceID, setSelectedSourceID] = useState(null);
  const [sources, setSources] = useState([]);

  const onChangeIlce = async (id) => {
    await axios
      .get(_serverUrl2 + "/main/mah/" + id)
      .then((res) => {
        if (res.data.status) {
          setMahalle(res.data.rows);
        }
      })
      .catch((err) => {});
  };

  const onChangeMahalle = async (id) => {
    await axios
      .get(_serverUrl2 + "/main/csbm/" + id)
      .then((res) => {
        if (res.data.status) {
          setCsbm(res.data.rows);
        }
      })
      .catch((err) => {});
  };

  const onChangeCSBM = async (id) => {
    await axios
      .get(_serverUrl2 + "/main/kapi/" + id)
      .then((res) => {
        if (res.data.status) {
          setKapi(res.data.rows);
        }
      })
      .catch((err) => {});
  };

  const getInfosFromNode = async () => {
    await axios
      .get(_serverUrl2 + "/main/ilce")
      .then((res) => {
        if (res.data.status) {
          setIlce(res.data.rows);
        }
      })
      .catch((err) => {});
  };

  const onClickAddTable = async () => {
    let postJSON = {
      mahalle: document.getElementById("mahalle").value,
      mahalle_ad: document.getElementById("mahalle")[document.getElementById("mahalle").selectedIndex].innerHTML,
      csbm: document.getElementById("csbm").value,
      csbm_ad: document.getElementById("csbm")[document.getElementById("csbm").selectedIndex].innerHTML,
      kapi: document.getElementById("kapi").value,
      kapi_ad: document.getElementById("kapi")[document.getElementById("kapi").selectedIndex].innerHTML,
    };
    if (postJSON.mahalle === "0" && postJSON.csbm === "0") {
      return failed("Mahalle veya CSBM seçildiğinden emin olunuz.");
    }

    loadingSc(true);
    await axios
      .post(_serverUrl2 + "/data/getHSignFromAdress", postJSON)
      .then((res) => {
        if (res.data.status) {
          if (sources.filter((d) => d.name === res.data.rows.name).length === 0) {
            setSources((prevSources) => {
              const newSources = [...prevSources, res.data.rows];
              addFeaturesTotempLayer(res.data.rows.features);
              MyMap.getView().fit(tempLayer.getSource().getExtent(), MyMap.getSize(), { duration: 1000 });
              return newSources;
            });
          } else {
            failed("Zaten Eklenmiş Bilgi!");
          }
        } else {
          failed("Veriler Alınamadı. || " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Alınamadı. || " + err);
      })
      .finally(() => {
        loadingSc(false);
      });
  };

  const onClickTemizle = () => {
    document.getElementById("ilce").value = "0";
    document.getElementById("mahalle").value = "0";
    setMahalle([]);
    document.getElementById("csbm").value = "0";
    setCsbm([]);
  };

  const refreshMap = useCallback(() => {
    tempLayer.getSource().clear();
    if (sources.length === 0) {
      return;
    }
    sources.forEach((d) => {
      addFeaturesTotempLayer(d.features);
    });
    MyMap.getView().fit(tempLayer.getSource().getExtent());
  }, [sources]);

  useEffect(() => {
    getInfosFromNode();
    tempLayer.getSource().clear();
    MyMap.addLayer(tempLayer);
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, []);

  useEffect(() => {
    refreshMap();
  }, [refreshMap]);

  const onClickRemoveFeature = (s_id, f_id) => {
    setSources((prevSources) => {
      const newSources = prevSources.map((source) => {
        if (source.id === s_id) {
          const updatedFeatures = source.features.filter((feature) => feature.maks_kimlik_no !== f_id);
          return { ...source, features: updatedFeatures };
        }
        return source;
      });
      return newSources;
    });
  };

  const onClickRemoveSource = (s_id) => {
    setSources((prevSources) => {
      return prevSources.filter((source) => source.id !== s_id);
    });
  };

  const onClickSendData = async () => {
    let postArr = [];
    sources.forEach((s) => {
      s.features
        .filter((d) => d.check === false)
        .forEach((f) => {
          postArr.push({
            maks_num_kn: f.maks_kimlik_no,
            islem_durum: "YAPILMADI",
            ekleyen_kullanici: getUserInfo.Id,
            kapi_no: f.kapino,
            veri_kaynagi: "Kurum Yüklemesi WEB",
            geom: "POINT(" + f.x + " " + f.y + ")",
          });
        });
    });

    let cleanArr = [];

    postArr.forEach((d) => {
      if (postArr.filter((p) => p.maks_num_kn === d.maks_num_kn).length === 1) {
        cleanArr.push(d);
      } else if (cleanArr.filter((c) => c.maks_num_kn === d.maks_num_kn).length === 0) {
        cleanArr.push(d);
      }
    });

    if (cleanArr.length === 0) {
      failed("Eklenecek Veri Bulunamadı.");
      return;
    }
    loadingSc(true);

    const jsonString = JSON.stringify(cleanArr);
    let formData = new FormData();
    const file = new File([jsonString], "numarataj.json", {
      type: "application/json",
    });
    formData.append("file", file);

    await axios
      .post(_serverUrl2 + "/data/importHSign", formData)
      .then((res) => {
        if (res.data.status) {
          success("Veriler Yüklendi!");
        } else {
          failed("Veri eklenirken hata oluştu. ||" + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veri eklenirken hata oluştu. ||" + err);
      })
      .finally(() => {
        loadingSc(false);
      });
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">Veri Yönetimi</div>
        </div>
      </div>

      <div className="col-sm-12">
        <DataSidebar page={1} />
      </div>

      <div className="col-sm-12">
        <div className="textBox" style={{ color: "black", fontSize: "14px" }}>
          <div className="row">
            <div className="col-sm-12">
              <center>
                <b>Numarataj Seçimi</b>
              </center>
              <hr style={{ margin: "3px" }} />
            </div>
            <div className="col-sm-6">
              <select id="ilce" style={{ fontSize: "12px", margin: "1px" }} className="form-control form-select" onChange={(e) => onChangeIlce(e.target.value)}>
                <option value="0" disabled selected>
                  İlçe Seçiniz
                </option>
                {ilce.map((d, i) => {
                  return (
                    <option key={i} value={d.maks_kimlik_no}>
                      {d.ad}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-sm-6">
              <select id="mahalle" style={{ fontSize: "12px", margin: "1px" }} className="form-control form-select" onChange={(e) => onChangeMahalle(e.target.value)}>
                <option value="0" selected>
                  Mahalle Seçiniz
                </option>
                {mahalle.map((d, i) => {
                  return (
                    <option key={i} value={d.mah_id}>
                      {d.mah_adi}
                    </option>
                  );
                })}
              </select>
            </div>
            <div style={{ marginRight: "0px" }} className="col-sm-4">
              <select id="csbm" style={{ fontSize: "12px", margin: "1px" }} onChange={(e) => onChangeCSBM(e.target.value)} className="form-control form-select">
                <option value="0" selected style={{ fontWeight: "bold" }}>
                  Tüm CSBMler{" "}
                </option>
                {csbm.map((d, i) => {
                  return (
                    <option key={i} value={d.maks_kimlik_no}>
                      {d.yol_ismi + " " + d.yol_tipi}
                    </option>
                  );
                })}
              </select>
            </div>
            <div style={{ marginLeft: "0px", paddingLeft: "0px" }} className="col-sm-2">
              <select id="kapi" style={{ fontSize: "12px", margin: "1px" }} className="form-control form-select">
                <option value="0" selected style={{ fontWeight: "bold" }}>
                  Tüm Kapılar
                </option>
                {kapi.map((d, i) => {
                  return (
                    <option key={i} value={d.maks_kimlik_no}>
                      {d.kapino}
                    </option>
                  );
                })}
              </select>
            </div>
            <div style={{ marginRight: "0px", paddingRight: "0px" }} className="col-sm-2">
              <button className="redBtn" style={{ fontSize: "13px", marginTop: "3px" }} onClick={() => onClickTemizle()}>
                Temizle
              </button>
            </div>
            <div style={{ marginLeft: "0px", paddingLeft: "0px" }} className="col-sm-4">
              <button className="greenBtn" style={{ fontSize: "13px", marginTop: "3px" }} onClick={() => onClickAddTable()}>
                Tabloya Ekle
              </button>
            </div>

            <div className="col-sm-12">
              <hr style={{ margin: "6px" }} />
            </div>

            <div className="col-sm-12">
              {sources.length != 0 ? (
                <>
                  {sources.map((d, i) => {
                    return (
                      <div key={i}>
                        <div
                          className="d-flex d-inline"
                          style={{ padding: "5px", margin: "2px", border: "3px solid rgba(0,0,0,0.04)", backgroundColor: "rgba(0,0,0,0.02)", borderRadius: "3px" }}
                        >
                          <button
                            style={{ width: "95%" }}
                            className={selectedSourceID == d.id ? "orangeBtn" : "darkOrangeBtn"}
                            onClick={() => (selectedSourceID == d.id ? setSelectedSourceID(0) : setSelectedSourceID(d.id))}
                          >
                            {d.name} ( {d.features.length} Adet )
                          </button>
                          <button style={{ width: "5%" }} className="redBtn" onClick={() => onClickRemoveSource(d.id)}>
                            Sil
                          </button>
                        </div>
                        {d.id == selectedSourceID && (
                          <div style={{ maxHeight: "600px", overflowY: "auto" }}>
                            <table className="table table-sm table-bordered">
                              <tbody>
                                {d.features.length != 0 ? (
                                  d.features.map((f, i) => {
                                    return (
                                      <tr key={i}>
                                        <td
                                          style={{ width: "25px", borderLeft: +f.check ? "5px solid  rgb(160, 202, 140)" : "5px solid orange" }}
                                          onClick={() => zoomToFeatureByXY(f.x, f.y)}
                                        >
                                          <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                                        </td>
                                        <td>{f.kapino}</td>
                                        {!f.check ? (
                                          <td style={{ width: "100px" }}>
                                            <button className="redBtn" onClick={() => onClickRemoveFeature(d.id, f.maks_kimlik_no)}>
                                              Kaldır
                                            </button>
                                          </td>
                                        ) : (
                                          <td style={{ width: "100px" }}>
                                            <button className="greenBtn" disabled>
                                              Eklenmiş
                                            </button>
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td style={{ borderLeft: "4px solid orange" }} colSpan={3}>
                                      <i>Numarataj Bilgisi Bulunamadı</i>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <br />
                          </div>
                        )}
                      </div>
                    );
                  })}
                  <hr style={{ margin: "6px" }} />
                  <div style={{ flexDirection: "row-reverse", alignContent: "left", alignSelf: "left", display: "flex" }}>
                    <button style={{ width: "285px" }} onClick={() => onClickSendData()} className="blueBtn">
                      Verileri Gönder
                    </button>
                  </div>
                </>
              ) : (
                <div style={{ padding: "10px" }}>
                  <WarningAlert
                    head="Numarataj Seçimi"
                    content="Mahalle veya sokak seçimiyle eklenecek numaratajlar burada gösterilecektir. Henüz tabloya bilgi eklemediniz."
                  />
                </div>
              )}
            </div>

            <div className="col-sm-7">&nbsp;</div>

            <div className="col-sm-5"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
